import type {
  ProductMap,
  Products,
  ProductSeries,
  SeriesMap,
  Sku,
} from "../types";

export const COLLECTION_2_CARDS = "Set2";
export const COLLECTION_3_CARDS = "Set3";
export const COLLECTION_RINGS = "Rings"; 
export const COLLECTION_FAMILY = "SetFamily"
export const COLLECTION_NWE_RINGS = "NweRings";
export const COLLECTION_ACCESSORIES = "Accessories";

export const productMap: ProductMap = {
  "TG115X2-S": {
    trKey: "pack2",
    series: "TG115",
    set: 2,
    img: {
      name: "pack2g1",
      width: 477,
      height: 618,
    },
  },
  "TG115X3-S": {
    trKey: "pack3",
    series: "TG115",
    set: 3,
    img: {
      name: "pack3g1",
      width: 477,
      height: 618,
    },
  },
  "TG128X2-B": {
    trKey: "pack2",
    series: "TG128",
    set: 2,
    img: {
      name: "pack2g2",
      width: 477,
      height: 618,
    },
  },
  "TG128X3-B": {
    trKey: "pack3",
    series: "TG128",
    set: 3,
    img: {
      name: "pack3g2",
      width: 477,
      height: 618,
    },
  },
  "TG130X2-B": {
    trKey: "pack2",
    series: "TG130",
    set: 2,
    img: {
      name: "pack2g2w",
      width: 834,
      height: 725,
    },
  },
  "TG130X3-B": {
    trKey: "pack3",
    series: "TG130",
    set: 3,
    img: {
      name: "pack3g2w",
      width: 834,
      height: 725,
    },
  },
};

export const seriesMap: SeriesMap = {
  TG115: {
    sets: { 3: "TG115X3-S" },
    badges: ["in-stock", "special-price"],
  },
  TG128: { sets: { 2: "TG128X2-B", 3: "TG128X3-B" }, isNew: true },
  TG130: {
    sets: { 2: "TG130X2-B", 3: "TG130X3-B" },
    isNew: true,
    badges: ["delivery-from"],
  },
};

export const productsHasGroup = (
  products: Products,
): products is ProductSeries =>
  (products as ProductSeries).series !== undefined;

export const getDefaultSku = (products: Products): Sku =>
  productsHasGroup(products)
    ? seriesMap[products.series[0]].sets[products.defaultInSet || 3] ||
      seriesMap[products.series[0]].sets[3]
    : products.defaultSku ?? products.variants[0];

export const numberProducedCards = 4000000 as const;
export const foundationYear = 2017;
